import React, { createContext, useContext, useState, useMemo } from 'react';

/**
 * Represents a range. Should not be treated as "indexes" because a range might
 * not be snapped to individual points
 */
export type Range = {
    start: number;
    end: number;
    vizId?: string;
};

export type RangeSelectionProviderContextOutput = {
    rangeSelection?: Range;
    setRangeSelection: (range?: Range) => void;
    isZoomed: boolean;
    setIsZoomed: (zoomed: boolean) => void;
};

const RangeSelectionProviderContext = createContext<RangeSelectionProviderContextOutput | undefined>(
    undefined
);

export const useRangeSelection = (): RangeSelectionProviderContextOutput | undefined =>
    useContext(RangeSelectionProviderContext);

export const RangeSelectionProvider = ({ children }: { children: React.ReactNode }) => {
    const [rangeSelection, setRangeSelection] = useState<Range>();
    const [isZoomed, setIsZoomed] = useState<boolean>(false);

    const contextValue = useMemo(
        () => ({ rangeSelection, setRangeSelection, isZoomed, setIsZoomed }),
        [rangeSelection, isZoomed]
    );

    return (
        <RangeSelectionProviderContext.Provider value={contextValue}>
            {children}
        </RangeSelectionProviderContext.Provider>
    );
};
